import React from 'react'
import { LoanLog } from '@matech/thebigpos-sdk'
import { useIntl } from 'react-intl'
import Badge, { BadgeProps } from '../Badge'
import { LogLevel } from './LoanLogSearchFilters'

export type LoanLogLevelBadgeProps = {
	level: LoanLog['level']
}

const LoanLogLevelBadge = ({ level }: LoanLogLevelBadgeProps) => {
	const { formatMessage } = useIntl()

	// Map LogLevel enum values to badge colors
	const levelColorMap: Record<LogLevel, BadgeProps['color']> = {
		None: 'info',
		Info: 'info',
		Warning: 'warning',
		Error: 'danger',
	}

	const levelLabel = formatMessage({
		id: `loan_log.level.${level.toLowerCase()}`,
		defaultMessage: level,
	})

	return (
		<Badge
			color={levelColorMap[level] || 'info'}
			label={levelLabel}
		/>
	)
}

export default LoanLogLevelBadge
